import React from 'react';

import Cell from './Cell/Cell';

import * as Utils from './Utils';

const getCellType = (cellData) => {
  if (typeof cellData === 'number') {
    return 'number';
  } else if (cellData === null) {
    return 'null';
  } else if (cellData === '#') {
    return '#';
  } else {
    console.warn('Unknown cell data type:', cellData);
  }
};

const crossword = (props) => {

  const rows = [];
  const cellReferences = {};
  
  const handleArrowKey = (direction, fromCellKey) => {
    const toCellKey = Utils.getDestinationCellKey(fromCellKey, direction, props.puzzle.length, props.puzzle[0].length);
    setTimeout(() => {
      cellReferences[toCellKey].ref.current.focus();
    }, 10);
  };

  for (let rowIndex=0; rowIndex<props.puzzle.length; rowIndex++) {
    const rowData = props.puzzle[rowIndex];
    const row = [];
    for (let colIndex=0; colIndex<rowData.length; colIndex++) {
      const cellData = rowData[colIndex];
      const cellType = getCellType(cellData);
      const answer = props.solution[rowIndex][colIndex];
      const key = Utils.encodeCellKey(rowIndex, colIndex);
      let isWrong = false;;
      if (Array.isArray(props.wrongAnswers)
          && props.wrongAnswers.length>0) {
        isWrong = !props.wrongAnswers[rowIndex][colIndex];
      }
      const ref = React.createRef();
      const cell = (
        <Cell type={cellType}
              playable={props.playable}
              crosswordEditable={props.editable}
              number={cellData}
              answer={answer}
              key={key}
              cellkey={key}
              onInputChange={props.onInputChange} 
              onInputFocus={props.onInputFocus}
              onArrowKey={handleArrowKey}
              onInputBlur={props.onInputBlur}
              isWrong={isWrong}
              ref={ref}
              isFocused={props.focusedCell === key} />
      );
      cellReferences[key] = cell;
      row.push(
        cell
      );
    }
    rows.push(<tr key={'row-'+rowIndex}>{row}</tr>);
  }
  
  return (
    <div style={props.visible ? {} : {display: 'none'}}
         className="crosswordGrid">
      <table className={['puzzle', 'size-'+props.size].join(' ')}>
        <tbody>
          { rows }
        </tbody>
      </table>
    </div>
  );
};

export default crossword;
